import { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const CHUNK = 5 * 1024 * 1024;

export function DesktopPortableUpload({ t, rel, onDone }) {
  const [busy, setBusy] = useState(false);
  const [pct, setPct] = useState(0);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true); setPct(0);
    try {
      const uploadId = `p${Date.now()}${Math.random().toString(36).slice(2, 8)}`;
      const total = Math.ceil(file.size / CHUNK);
      for (let i = 0; i < total; i++) {
        const fd = new FormData();
        fd.append("upload_id", uploadId); fd.append("index", String(i));
        fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK));
        await api.post("/admin/desktop/installer/chunk", fd);
        setPct(Math.round(((i + 1) / total) * 100));
      }
      const ff = new FormData();
      ff.append("upload_id", uploadId);
      await api.post("/admin/desktop/portable/finalize", ff);
      toast.success(t("Wgrano klienta desktopowego (portable)"));
      onDone?.();
    } catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || t("Błąd wgrywania")); }
    finally { setBusy(false); setPct(0); }
  };
  return (
    <div className="mb-3 rounded border border-slate-700 p-2.5" data-testid="ds-portable-box">
      <div className="text-[11px] text-slate-400 mb-2">
        {t("Wersja portable na tym serwerze")}: {rel?.portable_present
          ? <span className="text-emerald-400" data-testid="ds-portable-present">{t("wgrana")} ({Math.round((rel.portable_size || 0) / 1048576)} MB)</span>
          : <span className="text-amber-400" data-testid="ds-portable-missing">{t("brak — klienci pobior\u0105 j\u0105 z serwera producenta")}</span>}
      </div>
      <label className={`inline-flex items-center gap-2 rounded bg-sky-700 hover:bg-sky-600 px-3 py-1.5 text-xs cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`}>
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
        {busy ? `${t("Wgrywanie")} ${pct}%` : t("Wgraj FiberPass-Windows.zip")}
        <input type="file" accept=".zip" className="hidden" disabled={busy} data-testid="ds-portable-input"
          onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} />
      </label>
    </div>
  );
}
